export type ContractualAccountScope = 'AllContractualAccounts' | 'SpecificContractualAccounts';

export const ContractualAccountScope = {
    AllContractualAccounts: 'AllContractualAccounts' as ContractualAccountScope,
    SpecificContractualAccounts: 'SpecificContractualAccounts' as ContractualAccountScope
};
